/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import HintBox from "../../Box/HintBox/HintBox";
import EditIcon from "../../SvgIcon/EditIcon";
import React from "react";

const SummaryHintBox = () => {
  return (
    <HintBox headline={"Bitte überprüfen Sie Ihre Angaben!"}>
      <p>
        Überprüfen Sie hier kurz Ihre Angaben. Klicken Sie zum Ändern einfach auf <EditIcon color={"primary"} />. Wenn Sie alle Schritte erneut durchgehen
        möchten, klicken Sie unten auf "Alles bearbeiten".
      </p>
    </HintBox>
  );
};

export default SummaryHintBox;
